import { inject, Injectable } from '@angular/core';
import { API_URLS, WebServiceProvider } from '@pinnakl/core/web-services';
import { SecurityAssetType } from '@pinnakl/securities/domain';

@Injectable({ providedIn: 'root' })
export class AssetTypesApiService {
  private readonly wsp = inject(WebServiceProvider);
  private readonly apiUrls = inject(API_URLS);

  getAssetTypes(): Promise<SecurityAssetType[]> {
    return this.wsp.get<SecurityAssetType[]>({ endpoint: this.apiUrls.assetTypesV3 });
  }
}
